<div class="libraries-page-container" style="height: 100%;">
<div style="height: 100%; width: 100%;">
    <optima-explorer 
    [explorerAttributes]="explorerAttributes()" 
    [isLoading]="isLoading()"
    [contentTotalCount]="getContentTotalCount()"
    [contentItemCountPerPage]="contentItemCountPerPage"
    [dataRefreshedToken]="dataRefreshedToken()"
    (paginationRequest)="onPaginationRequest($event)"
    (explorerNavOnNavItemClickedEmitter)="onItemSelected($event)"
    (subHeaderOnClickAddButtonEmitter)="onAddButtonClicked($event)"
    (subHeaderOnClickAddButtonOptionEmitter)="onAddButtonOptionClicked($event)"
    (subHeaderOnClickFilterButtonEmitter)="onFilterButtonClicked()"
    (explorerContentOncontextMenuClickEmitter)="onContextMenuClicked($event)"
    (explorerContentOnListItemClickedEmitter)="onListItemClicked($event)"
    (explorerNavonExplorerNavOnItemRightClickEmitter)="onNavItemRightClick($event)"
    (explorerGridOnGridItemClickedEmitter)="onGridItemClicked($event)"
    (explorerNavOnHierarchyChangeEmitter)="onHierarchyChange($event)"
    (subHeaderOnForwardButtonClickedEmitter)="onForwardButtonClicked($event,false)"
    >
    
    <!-- File Viewer Container - handles all viewer routing -->        
    <app-file-viewer-container
      #fileViewerContainer
      [isViewerActive]="explorerAttributes().explorerContentAttributes?.isApplicationDerivedContent || false"
      [category]="category"
      [bizEntityId]="bizEntityId"
      [mode]="mode"
      [onBack]="onViewerBack"
      style="height: 100%;">
    </app-file-viewer-container>
  </optima-explorer>
</div>

  <!-- File Upload Component -->
  <app-file-upload 
    #fileUpload
    [availableFolders]="availableFolders"
    [showUploadDialog]="showUploadDialog"
    [selectedUploadFolder]="selectedUploadFolder"
    (uploadStarted)="onUploadStarted()"
    (uploadCompleted)="onUploadCompleted($event)"
    (uploadCancelled)="onUploadCancelled()"
    (folderSelected)="selectUploadFolder($event)">
  </app-file-upload>

  <!-- Floating Action Button -->
  <button cButton
    class="position-fixed fixed-btn end-0 m-3 mb-5 rounded-circle shadow d-flex justify-content-center align-items-center"
    [ngStyle]="{
      'width': '3.125rem', 
      'height': '3.125rem', 
      'z-index': '1045',
      'background-color': (explorerAttributes().explorerContentAttributes?.isApplicationDerivedContent) ? '#eba611' : '',
      'border-color': (explorerAttributes().explorerContentAttributes?.isApplicationDerivedContent) ? '#eba611' : '',
      'transform': isOpen && (explorerAttributes().explorerContentAttributes?.isApplicationDerivedContent) ? 'scale(1.05)' : 'scale(1)',
      'transform-origin': 'center center',
      'transition': 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
      'will-change': 'transform, box-shadow',
      'backface-visibility': 'hidden',
      'box-shadow': isOpen && (explorerAttributes().explorerContentAttributes?.isApplicationDerivedContent) ? '0 6px 20px rgba(235, 166, 17, 0.5)' : ''
    }" 
    (click)="toggleBox($event)">
    @if (explorerAttributes().explorerContentAttributes?.isApplicationDerivedContent) {
      <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg"
        [ngStyle]="{
          'transform': 'rotate(0deg)', 
          'transition': 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1)'
        }">
        <path d="M7.5 6.5H15.5M7.5 10.498H12.5M7.5 14.5H15.5" 
          [attr.stroke]="isOpen ? '#ffffff' : 'currentColor'" 
          stroke-width="1.5"
          stroke-linecap="round" 
          stroke-linejoin="round"/>
        <path fill-rule="evenodd" clip-rule="evenodd" 
          d="M4.499 7.5C4.999 7.5 5.499 7 5.499 6.5C5.499 6 4.999 5.5 4.499 5.5C3.999 5.5 3.5 6 3.5 6.5C3.5 7 3.999 7.5 4.499 7.5ZM4.499 11.5C4.999 11.5 5.499 11 5.499 10.5C5.499 10 4.999 9.5 4.499 9.5C3.999 9.5 3.5 10 3.5 10.5C3.5 11 3.999 11.5 4.499 11.5ZM4.499 15.5C4.999 15.5 5.499 15 5.499 14.5C5.499 14 4.999 13.5 4.499 13.5C3.999 13.5 3.5 14 3.5 14.5C3.5 15 3.999 15.5 4.499 15.5Z" 
          [attr.fill]="isOpen ? '#ffffff' : 'currentColor'"/>
      </svg>
    } @else {
      <svg cIcon 
        name="cilPlus" 
        size="xl"
        [ngStyle]="{
          'transform': isOpen ? 'rotate(-45deg)' : 'rotate(0deg)', 
          'transition': 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1), color 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          'color': isOpen ? '#ffffff' : ''
        }">
      </svg>
    }
  </button>

  <!-- FAB Menu (for creating files/folders) -->
  <optima-context-menu #menu [model]="menuItems()" [appendTo]="'body'"></optima-context-menu>
  
  <!-- SVG Context Menu (for three dots on thumbnails) -->
  <!-- <optima-context-menu #svgContextMenu [model]="svgContextMenuItems()"></optima-context-menu> -->
</div>
